import type { DialFormat } from "../engine/model";

/**
 * Seed slopes for Add grinder. The slope is per dial step (ln-time change per one number on the dial) and only seeds
 * the predictor: grinder slope learning replaces it after a few beans. The three named grinders use the values the
 * app ships with; the generic ones are rough guesses, labelled as such in the form.
 */
export interface GrinderPreset {
  readonly id: string;
  readonly label: string;
  readonly slope: number;
  readonly rough: boolean;
  /** suggested dial layout, filled into the form when picked */
  readonly dial: { readonly format: DialFormat; readonly min: number; readonly max: number; readonly step: number } | null;
}

export const UNKNOWN_SLOPE = -0.2;

export const GRINDER_PRESETS: readonly GrinderPreset[] = [
  { id: "pico", label: "La Marzocco Pico", slope: -0.22, rough: false, dial: { format: "decimal", min: 5, max: 10, step: 0.1 } },
  { id: "niche", label: "Niche Zero", slope: -0.15, rough: false, dial: { format: "decimal", min: 10, max: 20, step: 0.1 } },
  { id: "sette", label: "Baratza Sette 270 / 270Wi", slope: -0.3, rough: false, dial: { format: "macro_micro", min: 1, max: 15, step: 1 / 9 } },
  { id: "flat", label: "Flat burr, numbered dial (DF64 style)", slope: -0.04, rough: true, dial: { format: "decimal", min: 0, max: 90, step: 1 } },
  { id: "conical", label: "Conical electric, numbered dial (Eureka, Baratza style)", slope: -0.08, rough: true, dial: { format: "decimal", min: 1, max: 40, step: 1 } },
  { id: "hand", label: "Hand grinder, clicks (Comandante, 1Zpresso, Kingrinder)", slope: -0.06, rough: true, dial: { format: "decimal", min: 0, max: 40, step: 1 } },
  { id: "unknown", label: "Unknown / other", slope: UNKNOWN_SLOPE, rough: true, dial: null },
];

export function presetById(id: string): GrinderPreset {
  return GRINDER_PRESETS.find((p) => p.id === id) ?? (GRINDER_PRESETS[GRINDER_PRESETS.length - 1] as GrinderPreset);
}
